import React, {Component} from 'react';
import CurrencyInput from '../../components/inputs/currency_input';

class RateLineItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			rate: this.props.rate ? this.props.rate.node.rate : null,
			isNewRole: !this.props.rate || !this.props.rate.node.rate,
		};
	}

	UNSAFE_componentWillReceiveProps(nextProps) {
		this.setState({
			isNewRole: !nextProps.rate || !nextProps.rate.node.rate,
		});
	}

	handleRateChange(value) {
		this.setState({rate: value});
	}

	handleRateBlur() {
		if ((this.props.rate ? this.props.rate.node.rate : null) !== this.state.rate) {
			this.props.handleRateUpdate(
				this.state.rate,
				this.props.rate ? this.props.rate.node.id : null,
				this.props.rateCardId,
				this.props.role.id,
				this.state.isNewRole
			);
		}
	}

	render() {
		return (
			<tr className="rate-card-row">
				<td data-cy={this.props.cy}>{this.props.role.name}</td>
				<td>
					<CurrencyInput
						value={this.state.rate}
						onChange={this.handleRateChange.bind(this)}
						onBlur={this.handleRateBlur.bind(this)}
						placeholder={this.props.placeholder}
						currency={this.props.currency}
						allowDecimals={true}
						blurOnEnter={true}
						disabled={this.props.disabled}
						dataCy={'role-rates'}
					/>
				</td>
			</tr>
		);
	}
}
export default RateLineItem;
